import { createStore, thunk } from 'easy-peasy'

import PageBuilderModel from './models/PageBuilder.model'
import ScorecardModel from './models/Scorecard.model'
import ScoreTiers from './models/ScoreTiers.model'
import ColorsModel from './models/Colors.model'
import QuizQuestionsModel from './models/QuizQuestions.model'
import QuestionsBuilderModel from './models/QuestionsBuilder.model'
import ThemeModel from './models/Theme.model'
import AIAssistantModel from './models/AIAssistant.model'

// eslint-disable-next-line import/prefer-default-export
export const createBuilderStore = initialData =>
	createStore(
		{
			aiAssistant: new AIAssistantModel().model,
			activeScorecard: new ScorecardModel(initialData).model,
			builder: initialData.page ? new PageBuilderModel(initialData).model : {},
			scoreTiers: new ScoreTiers(initialData).model,
			colors: new ColorsModel(initialData).model,
			quiz: {
				questions: new QuizQuestionsModel(initialData).model,
				builder: new QuestionsBuilderModel(initialData).model,
			},
			signups: {
				data: [],
			},
			gallery: {
				upload: {
					request: thunk(() => {
						throw new Error('Uploading is not available.')
					}),
				},
			},
			theme: new ThemeModel(initialData).model,
		},
		{ name: 'BuilderStore' },
	)
